import {Plane, Text} from '@react-three/drei'
import {useRef, useState } from 'react'
import {useFrame} from '@react-three/fiber'
import {useInteraction, useXR } from '@react-three/xr'
export const Resultpane = ({count,speed,setStartgame}) => {
    const ref = useRef()
    const session = useXR((state) => state.session)
    useInteraction(ref, 'onSelect', (event) => {session.end(); setStartgame(false) ;})

    const [finished, setFinished] = useState(false)
    const [correct, setCorrect] = useState(0)
    const [answered, setAnswered] = useState(0)
    const [incorrect, setIncorrect] = useState(0)
    const [total, setTotal] = useState(0)
    useFrame((_, delta) => {
        if (!finished) {
            if ((ref.current.position.z < 1) )  {
                ref.current.position.z += speed * delta 
            }
            else {
                setFinished(true)
                var questions = ref.current.parent.children;
                var ans =0 , cor=0, incor=0,tot =0;
                tot = questions.length-1;
                questions.forEach((question) => { 
                    console.log(question.userData); 
                    if (question.userData.answered) 
                    {
                        ans += 1;
                    }
                    if (question.userData.correct)
                    {
                        cor += 1;
                    }
                    if (question.userData.incorrect)
                    {
                        incor += 1;
                    }
                });
                setAnswered(ans);
                setCorrect(cor);
                setIncorrect(incor);
                setTotal(tot);
                
            }
        }
        

    });


    return (

        <Plane ref={ref} onPointerDown={() => {console.log('down'); setStartgame(false);}}
        position={[0,0,(count*-6)-2]}
        args={[1, 1]} // Width, height
  
      >
        <Text color="black" fontSize={0.1} position-z={0.01} position-y={-0.2}>
          Total :  {total}
        </Text>
        <Text color="black" fontSize={0.1} position-z={0.01} position-y={0.0} >
          Answered:{answered}
          </Text>
        <Text color="black" fontSize={0.1} position-z={0.01}position-y={0.2} >
          Correct:{correct}
          </Text>
        <Text color="black" fontSize={0.1} position-z={0.01}position-y={0.4} >
          Incorrect:{incorrect}
          </Text>
          <Text color="black" fontSize={0.1} position-z={0.01}position-y={-0.4} >
           Click here to go back
          </Text>
        
      </Plane>
    );
}